<template>
	<el-dialog :visible.sync="centerDialogVisible" width="420px" center class="login-dailog" :close-on-click-modal="false" :before-close="handleClose">
		<div class="dailog-box">
			<div class="txt">登錄帳號密碼</div>
			<el-form ref="form" :model="form" :rules="rules" >
			  <el-form-item  prop="username" >
				<el-input v-model="form.username" placeholder="會員帳號" @keyup.native.enter="onSubmit">
					
					<template slot="prepend">
						<icon slot="prefix" name="user-alt" scale="1"></icon>
					</template>

				</el-input>
			  </el-form-item>
			  <el-form-item  prop="password">
				<el-input type="password" v-model="form.password" placeholder="會員密碼" @keyup.native.enter="onSubmit">
					<template slot="prepend">
						<icon slot="prefix" name="lock" scale="1"></icon>
					</template>
				</el-input>
			  </el-form-item>

				<el-alert :title="errors.title" type="error" show-icon class="error" :closable="false" v-if="errors.show"></el-alert>

			  <el-form-item>
					<el-button type="primary" @click="onSubmit" style="width:100%">登錄</el-button>
			  </el-form-item>

			  <el-form-item>
					<el-button type="info" @click="go2page('forget')" style="width:100%">忘記密碼</el-button>
			  </el-form-item>

              <!-- <el-form-item>
                如您沒有帳號?
                <el-button type="text" @click="go2page('register')">點擊註冊</el-button>
                <el-button type="text" @click="go2page('forget')" class="forget-pwd">忘記密碼?</el-button>
              </el-form-item> -->
			</el-form>

		</div>
		<div class="dailog-footer">
			登錄時有任何問題，請聯繫我們24小時在線客服協助解決
		</div>

	</el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data() {
		const validateUsername = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('請輸入會員帳號'));
			} else {
				this.form.disable = false;
				callback();
			}
		};
		const validatePassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('請輸入會員密碼'));
			} else {

				callback();
			}
		};

		return {
			errors:{
				show : false,
				title : '帳號名或密碼錯誤'
			},
			//activeIndex: this.$router.currentRoute.path,
			centerDialogVisible: false,
			form: {
				username: '',
				password: '',
			},
			rules: {
				username: [{
					validator: validateUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: validatePassword,
					trigger: 'blur'
				}],
			},
		};
	},
	methods: {
		handleClose(done){
			if (/^\/user/.test(this.$router.currentRoute.path)){
				this.$router.replace('/');
			}
			done();
		},
        go2page(page){
			this.centerDialogVisible = false;
            let cmd = page;
            this.$router.push('/' + cmd);
        },
		login() {
			this.centerDialogVisible = true;
		},
		logout(){
			this.$confirm('是否登出會員?', '提示', {
				confirmButtonText: '確定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal : false
			}).then(() => {
				this.$axios({
					method : 'POST',
					url : this.config.ApiUrl + '/api/logout',
					headers: {
						'Content-Type': 'application/json'
					}
				}).then(response => {
					this.user.isLogin = false;
					this.centerDialogVisible = false;
					//this.$layer.msg('登出成功');

					this.$message({
						type: 'success',
						message: response.data.message
					});

					if (/^\/user/.test(this.$router.currentRoute.path)){
						this.$router.replace('/uc/login');
					}
					this.user.wallet.refresh = false;
					this.user.wallet.totalAmounts = 0;
					//console.log(response.data);
				}).catch(error => {
					console.log(error);
				});

			}).catch(() => {
			
			});
		
		},
		onSubmit() {

			this.$axios({
				method : 'POST',
				url : this.config.ApiUrl + '/api/login',
				data: {
					'company' : this.config.company,
					'name' : this.form.username,
					'password' : this.form.password,
					'remember' : 'on'
				},
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				//console.log(response);
				if (!response.data.status) {
					return this.$layer.msg(response.data.message);
				}
				this.$store.dispatch('getUserInfo');
				//this.$store.dispatch('checkLogin');
				//this.user.isLogin = true;
				this.centerDialogVisible = false;
				//this.$layer.msg('登錄成功');
				this.$message({
					type: 'success',
					message: response.data.message
				});
				//console.log(response.data);
			}).catch(error => {
				this.$layer.msg(this.errors.title);
//				this.errors.show = true;
				console.log(error);
			});

		}
	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
		}),
    },
	created() {

		//console.log(this.$bet.alert('ddd'));
		//console.log('my',this.user);
		
		//this.$store.dispatch('actionAJAXexample');
	}
}
</script>
<style>
.el-button--info{
	color: #eaeaea;
}
.login-dailog .el-dialog__body {padding:0px;}
.login-dailog .dailog-footer {

	padding:12px 18px;
	font-size:14px;
	    color: #837c7c;
    line-height: 18px;

	letter-spacing: 1px;

    background: #1c202e;
	background-size: contain;
    color: #EEE;
}
.dailog-logo {
}
.dailog-box {padding:0 45px;}
.dailog-box .txt{font-size:18px;text-align:center;padding:10px 0 20px 0;color: #ddd}
.dailog-logo {
    display: block;
    width: 109px;
    height: 83px;

    margin: 0 auto 6px;
}
.dailog-box .error {
	margin-bottom:15px;
}

.forget-pwd{
    float: right;
}
.login-dailog .el-dialog{
	background: #333f56;
}
.login-dailog .el-form-item__content{
	color: #ddd
}
.login-dailog .el-button--text{
	color: #E4BB7B;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginBox.vue